// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
import { useFetchErrorContextConsumerHook } from 'contexts/fetch-error.context';
import { useKycContextConsumerHook } from 'containers/kyc/contexts/kyc.context';
// Event Handlers
import { KycMethodHandlers } from '../handlers/kyc-method.handlers';
// Types
import { KycMethodHookType } from './types/kyc-method.hook.type';

const useKycMethodHook = (): KycMethodHookType => {
  const { kycIdentificationId, kycIframeUrl, selectedMethod } = useKycContextConsumerHook(),
    { setError } = useFetchErrorContextConsumerHook(),
    { setCurrentState } = useAppContextConsumerHook();

  return {
    ...KycMethodHandlers({ kycIdentificationId, setCurrentState, setError }),
    kycIframeUrl,
    selectedMethod,
  };
};

export { useKycMethodHook };
